import React, { useEffect } from 'react';
import { Autocomplete, Grid, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import DateFnsUtils from '@date-io/date-fns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';
import moment from 'moment';
import {
	CLIENT_TYPES,
	DIVISIONS,
	PRIORITIES,
	TYPES_OF_PACKING,
} from '../utils/lists';
import {
	getOrderInfo,
	registerOrder,
	updateOrder,
	updateStats,
} from '../../actions/orders';
import {
	capLetters,
	defaultContacts,
	isInDevEnv,
	defaultContactsDev,
	getFullName,
	handleError,
	handleSuccess,
	whichDivison,
	whichPriority,
	whichTypeOfPacking,
	whichTypeOfClient,
	whichEnvURL,
	validateValues,
	handleWarning,
	handleInfo,
} from '../../helpers/utils';
import {
	diffDays,
	formatDateMX,
	getTodayDateMoment,
} from '../../helpers/hours';
import { Stack } from '@mui/system';
import { useNavigate, useParams } from 'react-router';
import { sendWhatsApp, template3 } from '../../helpers/whatsappApi';
import { getOrderContacts } from '../../actions/contact';
import { createWorkspace } from '../../actions/files';
import CurrencyFormat from 'react-currency-format';

export const TextFieldComponent = (params, label, required = true) => (
	<TextField
		fullWidth
		required={required}
		margin='normal'
		{...params}
		label={label}
	/>
);

export const NewOrderForm2 = ({ edit = false }) => {
	// URL params
	const { idOrder = null, orderType: orderTypeParam = 'Pedido' } =
		useParams();

	// Define state to know if it's loading or not
	const [isLoading, setIsLoading] = useState(false);

	// Form
	const [folio, setFolio] = useState('');
	const [division, setDivision] = useState(null);
	const [client, setClient] = useState(null);
	const [clientObj, setClientObj] = useState(null);
	const [entryDate, setEntryDate] = useState(getTodayDateMoment());
	const [deliveryTime, setDeliveryTime] = useState('45');
	const [priority, setPriority] = useState(null);
	const [pricesList, setPricesList] = useState(null);
	const [orderType, setOrderType] = useState(orderTypeParam);
	const [typeOfPacking, setTypeOfPacking] = useState(null);
	const [typeOfClient, setTypeOfClient] = useState(null);
	const [amount, setAmount] = useState(0);
	const [notes, setNotes] = useState('');
	const [createdBy, setCreatedBy] = useState(1);
	const [transport, setTransport] = useState('');
	const [consignedTo, setConsignedTo] = useState('');
	const [contactsList, setContactsList] = useState([]);

	// Check for empty values
	const validateForm = () => {
		const emptyValues = validateValues([
			division,
			client,
			entryDate,
			deliveryTime,
			priority,
			amount,
			typeOfPacking,
			typeOfClient,
		]);

		if (emptyValues.length) {
			handleWarning('Hay campos vacíos');
			return false;
		}
		return true;
	};

	// Dates
	const [deliveryDate, setDeliveryDate] = useState('');
	const [deliveryForecast, setDeliveryForecast] = useState('');

	// Current user
	const { user, clients } = useSelector((state) => state);

	// Navigation
	const navigate = useNavigate();

	// Path
	const path = `/dashboard/ordenes`;

	const handleContactListWhatsapp = async (order) => {
		// Get order contacts from DB
		const response = (await getOrderContacts(order?.id)).data;

		if (whichEnvURL(true) !== 'local') {
			// Create workspace in Firebase
			createWorkspace(order, user);
		}

		const clientAndUser = `${client}, registrado por el operador ${getFullName(
			user
		)}`;
		// Send WhatsApp
		sendWhatsApp(
			order,
			user,
			response?.ok ? response?.contacts : [],
			template3(clientAndUser, order?.number_order)
		)
			.then(({ data }) => {
				if (data?.ok || data?.msg.includes('sent')) {
					handleSuccess('Mensaje enviado');
					localStorage.setItem('currentPathPilu', path);
					if (orderType === 'Pedido') {
						// Set new path
						const path2 = `/dashboard/order/${order.id}`;
						navigate(path2);
					}
				} else {
					handleError(
						data?.msg,
						'Ocurrió un error al intentar enviar el mensaje. Intenta más tarde'
					);
				}
			})
			.catch((error) => {
				handleError(
					error,
					'Ocurrió un error al intentar enviar el mensaje. Intenta más tarde'
				);
			});
	};

	const generateFormData = () => {
		const addedDate = moment(entryDate)
			.add(parseInt(deliveryTime), 'days')
			.format('YYYY-MM-DD');

		return {
			number_order: folio,
			notes,
			transport,
			consigned_to: capLetters(consignedTo),
			amount: parseFloat(amount),
			delivery_date: edit ? deliveryDate : addedDate,
			client_id: edit
				? clientObj.id
				: clients.find((item) => item.company_name === client)?.id,
			division: DIVISIONS.find((item) => item.label === division).name,
			priority: PRIORITIES.find((item) => item.label === priority).name,
			type: orderType === 'Pedido' ? 'ORD' : 'QUO',
			was_a_quotation: orderType === 'Pedido' ? 0 : 1,
			type_of_packing: TYPES_OF_PACKING.find(
				(item) => item.label === typeOfPacking
			)?.name,
			type_of_client: CLIENT_TYPES.find(
				(item) => item.label === typeOfClient
			)?.name,
			entry_date: moment(entryDate).format('YYYY-MM-DD'),
			delivery_forecast: edit ? deliveryForecast : addedDate,
			created_by: createdBy,
			contacts: edit
				? contactsList.map((item) => item?.id)
				: isInDevEnv()
				? defaultContactsDev
				: defaultContacts,
		};
	};

	// Go to path
	const goTo = (currentPath) => {
		localStorage.setItem('currentPathPilu', currentPath);
		navigate(currentPath);
	};

	// Handle submit
	const handleSubmit = () => {
		// Set loading state to true
		setIsLoading(true);

		// if (!verifyInputNumberOrder(folio)) {
		// 	handleWarning('El folio no es válido, verifica que esté correctamente escrito.')
		// } else {
		// Generate payload
		const formData = generateFormData();

		if (edit) {
			// Update order
			updateOrder(idOrder, formData)
				.then(() => {
					// Feedback success
					handleSuccess('Pedido actualizado correctamente.');

					// Set new path
					const path2 = `/dashboard/order${
						edit ? `/${idOrder}` : ''
					}`;

					// Go to orders table
					goTo(path2);
				})
				.catch((error) => {
					handleError(error, 'No se pudo actualizar el pedido.');
				});
		} else {
			// Status ICF: in configuration
			const initialStatus = 'ICF';

			// Register new order
			registerOrder({
				...formData,
				status: initialStatus,
				created_by: user?.id,
			})
				.then(async ({ data: order }) => {
					// Feedback success
					handleSuccess('Pedido agregado correctamente.', false, 4);

					// Info message
					handleInfo('Cargando pedido...');

					// Handle alert whatsapp
					await handleContactListWhatsapp({
						...formData,
						...order,
						status: initialStatus,
						created_by: user,
					});

					// Update latest statistics
					updateStats().catch((error) => console.log(error));

					// Go to orders table or quotation engine
					goTo(
						// path
						orderType === 'Pedido'
							? path
							: `/dashboard/order/${order.id}/new-bias`
					);
				})
				.catch((error) => {
					handleError(error, 'No se pudo agregar el pedido.');
				});
		}
		// }

		setIsLoading(false);
	};

	useEffect(() => {
		if (!edit) {
			// Reset fields whenever the order type changes
			setAmount(0);
			setPricesList(null);
		}
	}, [orderType]);

	useEffect(() => {
		if (edit) {
			getOrderInfo(idOrder).then(({ data }) => {
				setContactsList(data.contacts);
				const diffDaysOrder = diffDays(
					formatDateMX(data?.entry_date),
					formatDateMX(data?.delivery_date)
				);
				setCreatedBy(data?.created_by?.id || 1);
				setDeliveryDate(data?.delivery_date);
				setDeliveryForecast(data?.delivery_forecast);
				setFolio(data?.number_order || '');
				setDivision(data ? whichDivison(data.division) : null);
				setClient(data ? data.client_id.company_name : null);
				setClientObj(data ? data.client_id : null);
				setEntryDate(
					data ? moment(data?.entry_date).format('MM/DD/YYYY') : null
					// data?.entry_date
				);
				setDeliveryTime(data ? diffDaysOrder : '30');
				setPriority(data ? whichPriority(data.priority) : null);
				setTypeOfPacking(
					data ? whichTypeOfPacking(data.type_of_packing) : null
				);
				setTypeOfClient(
					data ? whichTypeOfClient(data.type_of_client) : null
				);
				console.log(data?.amount);
				setAmount(data ? data.amount : '');
				setNotes(data ? data.notes : '');
				setTransport(data ? data.transport : '');
				setConsignedTo(data ? data.consigned_to : '');
				setOrderType(
					data
						? data.type === 'QUO'
							? 'Cotización'
							: 'Pedido'
						: null
				);
			});
		}
	}, []);

	return (
		<div style={{ padding: '25px' }}>
			<LocalizationProvider
				dateAdapter={AdapterDateFns}
				adapterLocale={es}
				utils={DateFnsUtils}
			>
				<Stack
					direction='column'
					alignItems='flex-start'
					justifyContent='space-between'
					style={{
						border: '1px solid white',
						padding: '20px 20px 0 0',
						margin: '0 0 10px 0',
						width: '100%',
					}}
				>
					<Typography variant='h4' gutterBottom>
						{orderType === 'Cotización'
							? 'Cotizaciones'
							: 'Pedidos'}
					</Typography>
					<Typography variant='p' gutterBottom>
						Complete el formulario para{' '}
						{edit ? 'editar la' : 'crear una nueva'} orden
					</Typography>
				</Stack>
				<hr />
				<Grid container spacing={2} className='mt-2'>
					{/* <Grid item xs={4}>
						<TextField
							disabled={edit}
							required
							fullWidth
							label='Folio'
							value={folio}
							onChange={({ target }) => setFolio(target.value)}
							helperText='Ingresa el folio sin espacios y en mayúsculas'
						/>
					</Grid> */}
					<Grid item xs={4}>
						<Autocomplete
							disabled={edit}
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={orderType}
							onChange={(_, value) => {
								setOrderType(value);
							}}
							options={['Cotización', 'Pedido']}
							renderInput={(params) =>
								TextFieldComponent(params, 'Tipo de pedido')
							}
						/>
					</Grid>

					<Grid item xs={4}>
						<Autocomplete
							disabled={edit}
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={division}
							onChange={(_, value) => {
								setDivision(value);
							}}
							options={DIVISIONS.map((item) => item.label)}
							renderInput={(params) =>
								TextFieldComponent(params, 'División')
							}
						/>
					</Grid>

					<Grid item xs={4}>
						<Autocomplete
							disabled={edit}
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={client}
							onChange={(_, value) => {
								setClient(value);
							}}
							options={clients.map((item) => item.company_name)}
							renderInput={(params) =>
								TextFieldComponent(params, 'Cliente')
							}
						/>
					</Grid>

					<Grid item xs={4}>
						<Autocomplete
							required
							style={{ marginTop: '-15px' }}
							fullWidth
							value={typeOfClient}
							onChange={(_, value) => {
								setTypeOfClient(value);
							}}
							options={CLIENT_TYPES.map((item) => item.label)}
							renderInput={(params) =>
								TextFieldComponent(params, 'Tipo de cliente')
							}
						/>
					</Grid>

					<Grid item xs={4}>
						{/* <DesktopDatePicker
							// disabled
							style={{
								marginTop: '107px',
								border: '1px solid red',
							}}
							fullWidth
							label='Fecha de ingreso'
							inputFormat='dd/MM/yyyy'
							// disablePast={true}
							name='entry_date'
							value={entryDate}
							onChange={(val) => {
								setEntryDate(val);
							}}
							renderInput={(params) =>
								TextFieldComponent(
									params,
									'Fecha de entrada',
									false
								)
							}
						/> */}
						<TextField
							disabled
							fullWidth
							name='entry_date'
							label='Fecha de entrada'
							value={formatDateMX(entryDate)}
						/>
					</Grid>

					<Grid item xs={4}>
						<TextField
							disabled={edit}
							required
							fullWidth
							type='number'
							label='Tiempo de entrega'
							value={deliveryTime}
							onChange={({ target }) =>
								setDeliveryTime(target.value)
							}
						/>
					</Grid>

					<Grid item xs={4}>
						<Autocomplete
							required
							style={{ marginTop: '-16px' }}
							fullWidth
							value={priority}
							onChange={(_, value) => {
								setPriority(value);
							}}
							options={PRIORITIES.map((item) => item.label)}
							renderInput={(params) =>
								TextFieldComponent(params, 'Prioridad')
							}
						/>
					</Grid>

					{(orderType === 'Pedido' || edit) && (
						<Grid item xs={4}>
							<CurrencyFormat
								customInput={TextField}
								value={amount}
								onValueChange={({ floatValue }) => {
									if (!isNaN(floatValue)) {
										setAmount(floatValue);
									} else {
										setAmount(0);
									}
								}}
								thousandSeparator={true}
								prefix={'$'}
								label='Importe (MXN)'
								helperText='El precio ya debe tener IVA'
								fullWidth
								required
								type='text'
							/>
						</Grid>
					)}

					<Grid item xs={4}>
						<Autocomplete
							required
							style={{ marginTop: '-15px' }}
							fullWidth
							value={typeOfPacking}
							onChange={(_, value) => {
								setTypeOfPacking(value);
							}}
							options={TYPES_OF_PACKING.map((item) => item.label)}
							renderInput={(params) =>
								TextFieldComponent(params, 'Tipo de empaque')
							}
						/>
					</Grid>

					{orderType === 'Cotización' && (
						<Grid item xs={4}>
							<Autocomplete
								required
								style={{ marginTop: '-16px' }}
								fullWidth
								value={pricesList}
								onChange={(_, value) => {
									setPricesList(value);
								}}
								// TODO: Create a model for this, do not add it into the lists.js file
								options={[
									'Precio licitación',
									'Precio por sede',
									'Precios original [1]',
									'Precios original [2]',
									'Precios original [3]',
								]}
								renderInput={(params) =>
									TextFieldComponent(
										params,
										'Lista de precios'
									)
								}
							/>
						</Grid>
					)}

					<Grid item xs={4}>
						{orderType === 'Pedido' && (
							<TextField
								fullWidth
								value={consignedTo}
								onChange={({ target }) =>
									setConsignedTo(target.value)
								}
								label='Consignado a'
								// helperText='Este campo puede ser agregado después'
							/>
						)}
					</Grid>
					<Grid item xs={4} />

					<Grid item xs={6}>
						{orderType === 'Pedido' && (
							<TextField
								style={{ margin: '5px 0 0 0' }}
								fullWidth
								margin='normal'
								placeholder='Transporte'
								multiline
								rows={3}
								// helperText='Este campo puede ser agregado después'
								value={transport}
								onChange={({ target }) => {
									setTransport(target.value);
								}}
							/>
						)}
					</Grid>

					{orderType === 'Pedido' && (
						<Grid item xs={6}>
							<TextField
								style={{ margin: '5px 0 0 0' }}
								fullWidth
								margin='normal'
								placeholder='Notas extra'
								multiline
								rows={3}
								value={notes}
								onChange={({ target }) => {
									setNotes(target.value);
								}}
							/>
						</Grid>
					)}
				</Grid>
				<Grid container spacing={2} className='mt-2'>
					<Grid item xs={6}>
						<LoadingButton
							fullWidth
							size='large'
							color='error'
							onClick={() => {
								let path2 = `/dashboard/${
									orderTypeParam === 'Cotización'
										? 'cotizaciones'
										: 'ordenes'
								}`;
								if (edit) {
									path2 = `/dashboard/order/${idOrder}`;
								}
								localStorage.setItem('currentPathPilu', path2);
								navigate(path2);
							}}
							variant='contained'
							loading={false}
						>
							Cancelar
						</LoadingButton>
					</Grid>

					<Grid item xs={6}>
						<LoadingButton
							fullWidth
							size='large'
							type='submit'
							variant='contained'
							loading={isLoading}
							style={{ backgroundColor: '#143f6c' }}
							onClick={() => {
								if (validateForm()) {
									if (orderType === 'Cotización') {
										// Set amount to 0
										setAmount(0);
									}

									// Handle submit
									handleSubmit();
								}
							}}
						>
							{edit ? 'Actualizar' : 'Guardar'}
						</LoadingButton>
					</Grid>
				</Grid>
			</LocalizationProvider>
		</div>
	);
};
